import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
  root: {
    '& .MuiRadio-colorSecondary.Mui-checked': {
      color: theme.palette.primary.main,
    },
  },
  typeTitle: {
    fontWeight: 'bold',
    fontSize: 16,
    color: '#3f505a',
  },
  radio: {
    color: '#b0bec5',
    marginInlineStart: theme.spacing(1),
  },
  hintIcon: {
    fontSize: 20,
    color: theme.palette.grey[600],
    marginInlineStart: theme.spacing(2),
    marginInlineEnd: theme.spacing(1),
  },
  hintTxt: {
    fontSize: 14,
    color: theme.palette.grey[600],
  },
}));